import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-oursegments',
  templateUrl: './oursegments.component.html',
  styleUrls: ['./oursegments.component.css']
})
export class OursegmentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
